var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p-20 text-center" }, [
      _c("img", {
        attrs: {
          start: "max-width: 100%",
          src: "http://pic.51yuansu.com/pic3/cover/01/33/92/5924815b1022c_610.jpg",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }